/**
 * Utilities to show/hide 3rd party chat widgets (e.g. when a drawer opens).
 * Add other chat providers to the same function bodies as they're integrated.
 */

const getAppcuesChecklists = () =>
  document.querySelector<HTMLElement>("appcues-checklists");

export const showChatWidget = () => {
  window.Pylon?.("showChatBubble");

  const appcuesChecklists = getAppcuesChecklists();
  appcuesChecklists?.style.removeProperty("opacity");
  appcuesChecklists?.style.removeProperty("pointer-events");
};

export const hideChatWidget = () => {
  window.Pylon?.("hideChatBubble");

  const appcuesChecklists = getAppcuesChecklists();
  appcuesChecklists?.style.setProperty("opacity", "0");
  appcuesChecklists?.style.setProperty("pointer-events", "none");
};
